export * from './zgxlszkc.component';